import { Injectable } from '@angular/core';
import { ILocationInfo, ISummaryData, ProductInformation } from '../models/summary-data';
import { IVehicleData } from '../models/vehicle-data.model';

const STORAGE_KEY = 'summaryData';

@Injectable({
  providedIn: 'root'
})
export class SummaryService {
  private summaryData: ISummaryData = {
    vehicleData: {} as IVehicleData,
    locationInfo: {} as ILocationInfo,
    productInformation: {} as ProductInformation
  };

  setSummary(data: ISummaryData): void {
    this.summaryData = data;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(this.summaryData));
  }

  getSummary(): ISummaryData | null {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  }

  clearSummary(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.summaryData = {
      vehicleData: {} as IVehicleData,
      locationInfo: {} as ILocationInfo,
      productInformation: {} as ProductInformation
    };
  }
}
